<ng-template #groupTemplate>
  @if (item) {
    <!--Add check for addEvent-->
    <tr
      app-table-row
      [columns]="config.columns"
      [actions]="config.customActions"
      [defaultActions]="config.actions!"
      [item]="item"
      [itemLabel]="config.itemLabel"
      [itemName]="config.getDisplayName(item.instance)"
      (addEvent)="item.Children != null ? addItemToGroup($event) : null"
      (moveEvent)="moveEvent.emit($event)"
      (deleteEvent)="removeEvent.emit($event)"
      (collapseEvent)="collapse()"
      (selectEvent)="selectEvent.emit(item)"
      [isLast]="isLast"
      [isFirst]="isFirst"
      [showCollapseButton]="
        item.Children != null && item.Children.length !== 0 ? showCollapseButton : false
      "
      [isCollapsed]="item.collapse ?? false"
      [enableSelect]="enableSelect"
      [disableSelectButton]="disableSelectButtons"
      [emptyColumnsAtStart]="
        showIndent
          ? currentLevel
          : showCollapseButton && (item.Children == null || item.Children.length === 0)
            ? 1
            : 0
      "
      [whiteColumnsAtStart]="showIndent ? currentLevel : 0"
      [firstColumnColspan]="
        showCollapseButton
          ? showIndent
            ? totalLevels -
              currentLevel -
              (item.Children == null || item.Children.length === 0 ? 0 : 1)
            : 1
          : showIndent
            ? totalLevels - currentLevel
            : 1
      "
      class="bg-table-gray-{{ grayLevel }}"
    ></tr>
    @if (item.collapse !== true) {
      @for (child of item.wrapperChildren; track child.Id) {
        <app-table-group
          [item]="child"
          [config]="config"
          [isFirst]="$first"
          [isLast]="$last"
          (removeEvent)="removeItem($index)"
          (moveEvent)="moveItem($event.action, $event.item, $index, $event.direction)"
          (selectEvent)="handleSelect($event)"
          [showCollapseButton]="showCollapseButton"
          [showIndent]="showIndent"
          [enableSelect]="enableSelect"
          [disableSelectButtons]="disableSelectButtons"
          [totalLevels]="totalLevels"
          [currentLevel]="currentLevel + 1"
        ></app-table-group>
      }
    }
  }
</ng-template>
